import React, { Suspense, useEffect } from "react";
import * as router from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import { toast as notify } from "react-toastify";

import OpenAccount from "../account";

import Loading from "../../components/loading";

import * as _ from "lodash";
import { makeGetToast } from "../../lib/selector";

import { usePrevious } from "../../lib/useHook";

// const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
// const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <router.Route
      {...rest}
      render={(props) => {
        return <Component {...props} store={rest.dispatch.store} />;
      }}
    />
  );
};

function DefaultLayout(props) {
  const dispatch = useDispatch();

  const { toast } = props;

  const prevToast = usePrevious(toast);

  useEffect(() => {
    if (toast && toast.msg && !_.isEqual(toast, prevToast)) {
      if (toast.type) {
        notify[toast.type](toast.msg?.message || toast.msg);
      } else notify.info(toast.msg?.message || toast.msg);
      // clear toast
      dispatch({ type: "CLEAR_TOAST" });
    }
  }, [toast]);

  return (
    <>
      {/* <Suspense fallback={<Loading />}>
        <DefaultHeader onLogout={(e) => signOut(e)} />
      </Suspense> */}
      <div className="app-body">
        <main className="main">
          <Container fluid>
            <Suspense fallback={<Loading />}>
              <router.Switch>
                <PrivateRoute
                  path="/open-account/:typeId"
                  component={OpenAccount}
                  dispatch={props}
                />
                <router.Redirect
                  from="/open-account"
                  to="/open-account/check-info"
                />
              </router.Switch>
            </Suspense>
          </Container>
        </main>
      </div>
      {/* <Suspense fallback={<Loading />}>
        <DefaultFooter />
      </Suspense> */}
    </>
  );
}

const makeMapStateToProps = () => {
  const getToast = makeGetToast();

  const mapStateToProps = (state) => {
    return {
      toast: getToast(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(DefaultLayout);
